/**
 * The question model's names that the launch reads (T-0770, the entry budget): the item type a
 * decision is, and the codes of what can be wrong with a question as asked. A leaf, re-exported by
 * `questions.ts`, so the launch entry, which tells a decision by its type and a refused question by
 * its code, does not carry the validation and its English sentences (about 5 KB).
 */

/** The item type a decision is, and its key prefix (`D-0001`). */
export const DECISION_ITEM_TYPE_KEY = 'decision';
export const DECISION_ITEM_TYPE_PREFIX = 'D';

/**
 * I-2194 (F-0621): what can be wrong with a question as asked, by a stable code. The server, the CLI
 * and the web read these from here, so a page that words a problem in the reader's language
 * (`components.questionProblems.<code>`, the code itself the key) and the server that refuses it cannot name different rules.
 */
export const QUESTION_DEFINITION_PROBLEM_CODES = [
  'promptMissing',
  'promptTooLong',
  'selectionModeUnknown',
  'tooFewOptions',
  'tooManyOptions',
  'optionKeyInvalid',
  'optionKeyRepeated',
  'optionLabelMissing',
  'optionLabelTooLong',
  'optionConsequenceTooLong',
] as const;
export type QuestionDefinitionProblemCodeType = (typeof QUESTION_DEFINITION_PROBLEM_CODES)[number];
